<template lang="html">
	<div class="box">
		<header>
			<HeaderComponent></HeaderComponent>
		</header>
		<main>
			<router-view></router-view>
		</main>
	</div>
</template>

<script>
import HeaderComponent from "./component/HeaderComponent.vue"
export default {

	components: {
		HeaderComponent
	}
}
</script>


<style lang="css" scoped>
.box {
	display: flex;
	min-height: 100vh;
	flex-direction: column;
	background-image: url(./assets/底纹.jpg);
	font-family: 微软雅黑;
}
/*header {
	background-color: #5cadff;
	height: 100px;
}*/
main {
	flex-grow: 1;
}
/*footer {
	background-color: #3399ff;
	height: 100px;
}*/
</style>



// WEBPACK FOOTER //
// App.vue?669d7c7e